/**
 * OverviewTab Component
 *
 * Manager team overview dashboard tab.
 * Shows team performance summary, alerts, and quick actions.
 */

import TeamOverviewDashboard from '@/components/performance/manager/TeamOverviewDashboard'
import type { TeamMember } from '@/services/api/managerService'

interface OverviewTabProps {
  teamMembers: TeamMember[]
  isLegacyYear: boolean
  selectedYear: number
  onScheduleReview: (memberId: string) => void
  onViewMember: (memberId: string) => void
}

export function OverviewTab({
  teamMembers,
  isLegacyYear,
  selectedYear,
  onScheduleReview,
  onViewMember
}: OverviewTabProps) {
  // Legacy year notice
  if (isLegacyYear) {
    return (
      <div className="p-6">
        <div className="bg-amber-50 border border-amber-200 rounded-lg p-6 text-center">
          <h3 className="text-lg font-semibold text-amber-800 mb-2">Historical Year ({selectedYear})</h3>
          <p className="text-amber-700">
            Team impact & growth data for years before 2025 is available in the legacy F&O system.
            The new impact & growth platform tracks data from 2025 onwards.
          </p>
        </div>
      </div>
    )
  }

  return (
    <div className="p-6">
      <TeamOverviewDashboard
        teamMembers={teamMembers}
        onScheduleReview={onScheduleReview}
        onViewMember={onViewMember}
      />
    </div>
  )
}

export default OverviewTab
